import { createColumnHelper } from '@tanstack/react-table';
import { PolicyAssignedRateGroup } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Body, Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';

const columnHelper = createColumnHelper<PolicyAssignedRateGroup>();

const columns = [
    columnHelper.accessor('name', {
        header: () => lt('RateGroupPlural'),
        cell: (props) => (
            <Body size="small" wordBreak="break-all" ellipsis maxLines={1} as="span">
                {props.getValue()}
            </Body>
        ),
    }),
    columnHelper.accessor('serviceName', {
        header: () => lt('Service'),
    }),
];

interface Props {
    rateGroups: PolicyAssignedRateGroup[];
}
export const PolicyAssignedRateGroupsTabContent = ({ rateGroups }: Props) => {
    const [tableState, setTableState] = useTableState<PolicyAssignedRateGroup>({
        pagination: {
            show: false,
        },
    });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <TableHeader title={lt('RateGroupPlural')} subTitle={rateGroups.length} />
            <Table uniqueRowId="id" fixedFirstColumn data={rateGroups} amountOfRows={rateGroups.length} />
        </TableProvider>
    );
};
